import React, { Fragment, useEffect } from "react";
import { Box, Button } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { useForm, FormProvider } from "react-hook-form";
import { useListContext, CheckboxGroupInput } from "react-admin";

const ResourceFilter = () => {
  const [open, setOpen] = React.useState(false);

  const { displayedFilters, filterValues, setFilters, hideFilter } =
    useListContext();

  const statusData = [
    {
      status: 1,
      label:"Active"
      
    },
    {
      status: 0,
      label:"Inactive"
      
    },
  ];

  const form = useForm({
    defaultValues: filterValues,
  });

  // form submit handler
  const onSubmit = (value) => {
    setFilters({ ...value }, displayedFilters);
    setOpen(false);
  };
  
  useEffect(()=>{
    form?.setValue("q",filterValues?.searchcode);
  },[filterValues])
  const dialogTitle = (
    <DialogTitle id="alert-dialog-title" className="dialog_title_filters">
      Filters
    </DialogTitle>
  );

  const dialogContent = (
    <DialogContent className="dialog_content_filters">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Box sx={{ width: 450 }} component={"div"}>
            <Box
              className="card-s-title"
              display="flex"
              flexDirection={"column"}
              alignItems="flex-start"
              mb={1}
            >
              <Box component="span">
                <h6>Status</h6>
              </Box>
              <Box component="span" className="app-list">
                <CheckboxGroupInput
                  className="app_list_checkbox"
                  sx={{ marginTop: 0 }}
                  row={false}
                  label=""
                  source="Active"
                  choices={statusData?.map((item) => {
                    return {
                      id: item.status,
                      name: item.label,
                    };
                  })}
                />
              </Box>
            </Box>
            <Box display={"flex"} justifyContent={"end"}>
              <Button
                sx={{ mx: 1 }}
                onClick={() => {
                  setOpen(false);
                }}
                variant="outlined"
                color="secondary"
                type="button"
              >
                Cancel
              </Button>
              <Button sx={{ mx: 1 }} variant="contained" type="submit">
                Apply
              </Button>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </DialogContent>
  );

  return (
    <Fragment>
      <button
        onClick={() => setOpen(true)}
        type="button"
        className="g-line-btn"
        style={{minWidth:"2rem"}}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.11337 11C3.25111 10.6096 3.50653 10.2716 3.84444 10.0325C4.18235 9.79343 4.5861 9.66503 5.00004 9.66503C5.41398 9.66503 5.81773 9.79343 6.15564 10.0325C6.49355 10.2716 6.74897 10.6096 6.88671 11H13.6667V12.3333H6.88671C6.74897 12.7237 6.49355 13.0617 6.15564 13.3008C5.81773 13.5399 5.41398 13.6683 5.00004 13.6683C4.5861 13.6683 4.18235 13.5399 3.84444 13.3008C3.50653 13.0617 3.25111 12.7237 3.11337 12.3333H0.333374V11H3.11337ZM7.11337 6.33333C7.25111 5.94298 7.50653 5.60496 7.84444 5.36586C8.18235 5.12676 8.5861 4.99837 9.00004 4.99837C9.41398 4.99837 9.81773 5.12676 10.1556 5.36586C10.4935 5.60496 10.749 5.94298 10.8867 6.33333H13.6667V7.66667H10.8867C10.749 8.05702 10.4935 8.39504 10.1556 8.63414C9.81773 8.87324 9.41398 9.00163 9.00004 9.00163C8.5861 9.00163 8.18235 8.87324 7.84444 8.63414C7.50653 8.39504 7.25111 8.05702 7.11337 7.66667H0.333374V6.33333H7.11337ZM3.11337 1.66667C3.25111 1.27631 3.50653 0.938289 3.84444 0.699193C4.18235 0.460097 4.5861 0.331699 5.00004 0.331699C5.41398 0.331699 5.81773 0.460097 6.15564 0.699193C6.49355 0.938289 6.74897 1.27631 6.88671 1.66667H13.6667V3H6.88671C6.74897 3.39036 6.49355 3.72838 6.15564 3.96747C5.81773 4.20657 5.41398 4.33497 5.00004 4.33497C4.5861 4.33497 4.18235 4.20657 3.84444 3.96747C3.50653 3.72838 3.25111 3.39036 3.11337 3H0.333374V1.66667H3.11337ZM5.00004 3C5.17685 3 5.34642 2.92976 5.47145 2.80474C5.59647 2.67971 5.66671 2.51014 5.66671 2.33333C5.66671 2.15652 5.59647 1.98695 5.47145 1.86193C5.34642 1.7369 5.17685 1.66667 5.00004 1.66667C4.82323 1.66667 4.65366 1.7369 4.52864 1.86193C4.40361 1.98695 4.33337 2.15652 4.33337 2.33333C4.33337 2.51014 4.40361 2.67971 4.52864 2.80474C4.65366 2.92976 4.82323 3 5.00004 3ZM9.00004 7.66667C9.17685 7.66667 9.34642 7.59643 9.47145 7.4714C9.59647 7.34638 9.66671 7.17681 9.66671 7C9.66671 6.82319 9.59647 6.65362 9.47145 6.5286C9.34642 6.40357 9.17685 6.33333 9.00004 6.33333C8.82323 6.33333 8.65366 6.40357 8.52864 6.5286C8.40361 6.65362 8.33337 6.82319 8.33337 7C8.33337 7.17681 8.40361 7.34638 8.52864 7.4714C8.65366 7.59643 8.82323 7.66667 9.00004 7.66667ZM5.00004 12.3333C5.17685 12.3333 5.34642 12.2631 5.47145 12.1381C5.59647 12.013 5.66671 11.8435 5.66671 11.6667C5.66671 11.4899 5.59647 11.3203 5.47145 11.1953C5.34642 11.0702 5.17685 11 5.00004 11C4.82323 11 4.65366 11.0702 4.52864 11.1953C4.40361 11.3203 4.33337 11.4899 4.33337 11.6667C4.33337 11.8435 4.40361 12.013 4.52864 12.1381C4.65366 12.2631 4.82323 12.3333 5.00004 12.3333Z"
            fill="#909090"
          />
        </svg>
      </button>
      <Dialog
        className="filter-modal"
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {dialogTitle && dialogTitle}
        {dialogContent && dialogContent}
      </Dialog>
    </Fragment>
  );
};

export default ResourceFilter;
